import getOrdinalForNumber from "@/utils/numbers/getOrdinalForNumber";

export const getGradesText = (grades: string[]) => {
  return grades.reduce((acc: string, grade: string, index: number) => {
    let ordinal;

    switch (grade) {
      case "PK":
        ordinal = "Pre Kindergarten";
        break;
      case "K":
        ordinal = "Kindergarten";
        break;
      default:
        ordinal = getOrdinalForNumber(parseInt(grade));
    }

    const isLastItem = grades.length === index + 1;
    const gradeString = `${grades.length === 1 ? " grade" : " grades"}`;
    const gradeStringCondition =
      `${grade !== "K" && grade !== "PK" ? grade : ""}${ordinal}` +
      `${isLastItem ? gradeString : ", "}`;
    if (!acc) {
      acc = gradeStringCondition;
    } else {
      acc = acc + gradeStringCondition;
    }
    return acc;
  }, "");
};
